module.exports = __webpack_public_path__ + "static/media/Hotel-DolceVita.1887c36c.jpg";